// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_home-container__ydJSj {
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.styles_home-logo__vqKge {
  /* border: 1px solid #707070; */
  /* border-radius: 8px; */
  /* padding: 16px; */
  /* margin-bottom: 48px; */
}

.styles_form-item-label__wt4V8 {
  color: var(--primary-color);
  font-weight: 400;
  font-size: 16px;
}

.styles_form-item__12eC6 textarea {
  border-bottom: 1px solid #000000;
  border-radius: 0px;
}

.styles_form-item__12eC6 textarea:hover,
.styles_form-item__12eC6 textarea:focus {
  border-bottom: 1px solid #000000;
}

.styles_form-item--title__SqCgW {
  width: 75%;
}

.styles_form-item--description__-J8u1 {
  width: 50%;
}

.styles_form-item--title__SqCgW textarea {
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 32px;
  text-align: center;
}

.styles_form-item--description__-J8u1 textarea {
  font-weight: 400;
  font-size: 20px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/surveys-home/styles/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".home-container {\n  background-color: #fff;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.home-logo {\n  /* border: 1px solid #707070; */\n  /* border-radius: 8px; */\n  /* padding: 16px; */\n  /* margin-bottom: 48px; */\n}\n\n.form-item-label {\n  color: var(--primary-color);\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.form-item textarea {\n  border-bottom: 1px solid #000000;\n  border-radius: 0px;\n}\n\n.form-item textarea:hover,\n.form-item textarea:focus {\n  border-bottom: 1px solid #000000;\n}\n\n.form-item--title {\n  width: 75%;\n}\n\n.form-item--description {\n  width: 50%;\n}\n\n.form-item--title textarea {\n  font-weight: 700;\n  font-size: 32px;\n  margin-bottom: 32px;\n  text-align: center;\n}\n\n.form-item--description textarea {\n  font-weight: 400;\n  font-size: 20px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-container": `styles_home-container__ydJSj`,
	"home-logo": `styles_home-logo__vqKge`,
	"form-item-label": `styles_form-item-label__wt4V8`,
	"form-item": `styles_form-item__12eC6`,
	"form-item--title": `styles_form-item--title__SqCgW`,
	"form-item--description": `styles_form-item--description__-J8u1`
};
export default ___CSS_LOADER_EXPORT___;
